<template>
  <div class="d-flex flex-column" style="min-height: 100vh">
    <!-- logo -->
    <logo_display :target_url="'https://foreverliving.com/hkg/zh-hk/home'" />
    <!-- logo -->

    <!-- heading -->
    <page_banner :page_title="page_title" />
    <!-- heading -->

    <!-- content -->
    <div style="flex: 1">
      <b-container class="mb-5 mt-5 p3">
        <form_tree
          v-for="(category, index) in categorys"
          :key="index"
          :category="category"
          :index="index"
          :language="current_language"
        />
      </b-container>
    </div>
    <!-- content -->

    <span v-if="current_language == '中文'">
      <footer_page />
    </span>
    <span v-if="current_language == 'English'">
      <footer_page_eng />
    </span>
  </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, ref } from "vue";
import page_banner from "./page_banner.vue";
import logo_display from "./logo_display.vue";
import footer_page from "./footer_page.vue";
import footer_page_eng from "./footer_page_eng.vue";
import form_tree from "./form_tree.vue";
import api from "@/api";

const categorys = ref([]);

const page_title = ref("");

const language_version_valid_tabs = ref([]);
const current_language = ref("");

const load_language_version_from_url = () => {
  let hash = window.location.hash.slice(1);
  if (language_version_valid_tabs.value.includes(hash)) {
    current_language.value = hash;
  } else {
    current_language.value = "中文";
    window.location.hash = "#中文";
  }
};

const get_fbo_form = async () => {
  let language_version_response = await api.get("/api/get_language_version");
  language_version_response.data.forEach((data) => {
    language_version_valid_tabs.value.push(data.language_name);
  });

  load_language_version_from_url();
  categorys.value = [];
  let categorys_response = await api.get("/api/get_fbo_form");
  categorys.value = categorys_response.data;

  if (current_language.value == "中文") {
    page_title.value = "表格下載";
  } else if (current_language.value == "English") {
    page_title.value = "Form Download";
  }
};

onMounted(async () => {
  get_fbo_form();
  window.addEventListener("hashchange", get_fbo_form);
});

onBeforeUnmount(() => {
  window.removeEventListener("hashchange", get_fbo_form);
});
</script>
